import TableCell from '@material-ui/core/TableCell';
import PropTypes from 'prop-types';
import React from 'react';
import useStyles from './Cell.styles';

const Cell = ({ cell }) => {
  const classes = useStyles();

  return <TableCell classes={classes}>{cell.render('Cell')}</TableCell>;
};

Cell.propTypes = {
  cell: PropTypes.shape().isRequired,
};

export default Cell;
